/**
 * VOS-v2 — Spinner de marca. Usa currentColor, então herda a cor do contexto.
 */
import { t } from "../lib/i18n";
import { cn } from "../lib/cn";

const SIZE = { sm: "h-3.5 w-3.5", md: "h-5 w-5", lg: "h-7 w-7" } as const;

export function Spinner({
  size = "md",
  className,
  label = t("Carregando"),
}: {
  size?: keyof typeof SIZE;
  className?: string;
  label?: string;
}) {
  return (
    <svg
      className={cn("animate-spin", SIZE[size], className)}
      viewBox="0 0 24 24"
      fill="none"
      role="status"
      aria-label={label}
    >
      <circle className="opacity-20" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" />
      <path
        className="opacity-90"
        d="M22 12a10 10 0 0 1-10 10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
}
